module.exports = __webpack_public_path__ + "img/savlon-spray.f57f1e4d.jpg";